import React from 'react'

export default function TextArea({id, label, value, placeholder, onChange, error, script, disabled, type, rows, className}){
    return (
        <>
            <div className="font-semibold">
                {label && <label htmlFor={id}>{label}</label>}
            </div>
            <div className="mt-2">
                <textarea rows={rows} cols="50" id={id} placeholder={placeholder} type={type} disabled={disabled} value={value} onChange={onChange} className={`w-full border border-gray-300 rounded-lg p-2 ${error ? 'border-red-700' : ''} ${className} focus:outline-none focus:border-primary focus:ring-primary focus:ring-1 rounded-md border  border-gray-300 w-auto bg-white`} {...script} />
                <label className='text-red-700 italic'>{error}</label>
            </div>
        </>
    )
}